import React from "react";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";

const NumberInput = ({
	label,
	name,
	control,
	errors,
	placeholder,
	onKeyDown,
	autoFocus = false,
	className,
	required = false, // Adicione uma prop para required
	decimalScale = 0,
	// decimalSeparator = ",",
	// thousandSeparator = ".",
	// prefix = "R$ ",
	allowNegative = false,
	truncate = false,
	disabled = false,
}) => {
	return (
		<div className={`input-box ${className}`}>
			<label className={truncate && `truncate w-48`} htmlFor={name}>
				{label}
			</label>
			<Controller
				name={name}
				control={control}
				rules={{
					required: required ? "Este campo é obrigatório" : false,
				}}
				render={({ field: { onChange, onBlur, value, ref } }) => (
					<NumericFormat
						value={value} // Valor padrão para vazio
						onValueChange={(values) => {
							const numericValue = decimalScale === 0 ? parseInt(values.value, 10) : values.value;
							onChange(numericValue); // Passa o valor numérico puro para o formulário
						}}
						decimalScale={decimalScale} // Quantidade de casas decimais
						// decimalSeparator={decimalSeparator} // Separador de decimais
						// thousandSeparator={thousandSeparator} // Separador de milhares
						// prefix={prefix} // Prefixo, exemplo: R$
						// allowNegative={allowNegative} // Permitir números negativos
						// fixedDecimalScale={true} // Mostra sempre as casas decimais
						id={name}
						className={`${errors?.[name] ? "error" : ""} ${
							disabled ? "opacity-50 cursor-not-allowed" : ""
						}`}
						placeholder={placeholder}
						onBlur={onBlur}
						onKeyDown={onKeyDown}
						autoFocus={autoFocus}
						disabled={disabled}
					/>
				)}
			/>
			{errors?.[name] && <p className="errors">{errors[name].message}</p>}
		</div>
	);
};

export default NumberInput;

// import React from "react";
// import { Controller } from "react-hook-form";
// import { PatternFormat } from "react-number-format";

// const NumberInput = ({
// 	label,
// 	name,
// 	control,
// 	errors,
// 	placeholder,
// 	onKeyDown,
// 	autoFocus = false,
// 	className,
// 	format,
// }) => {
// 	return (
// 		<div className={`input-box ${className}`}>
// 			<label htmlFor={name}>{label}</label>
// 			<Controller
// 				name={name}
// 				control={control}
// 				render={({ field: { onChange, onBlur, value, ref } }) => (
// 					<PatternFormat
// 						value={value}
// 						onValueChange={(values) => onChange(values.value)}
// 						format={format}
// 						id={name}
// 						className={errors?.[name] ? "error" : ""}
// 						placeholder={placeholder}
// 						onBlur={onBlur}
// 						onKeyDown={onKeyDown}
// 						autoFocus={autoFocus}
// 						customInput={Input} // Um input básico
// 					/>
// 				)}
// 			/>
// 			{errors?.[name] && <p className="errors">{errors[name].message}</p>}
// 		</div>
// 	);
// };

// const Input = ({ ...props }) => <input {...props} />;

// export default NumberInput;
